import { getBoostSubscription } from './subscriptions';
import { getBoostTrial } from './trials';

export const getBoostSubscriptionAndTrialInfo = async () => {
    const getSub = async () => {
        let subscription;

        try {
            subscription = await getBoostSubscription();
        } catch (e) {
            console.log('Error getting subscription:', e);
            subscription = null;
        }

        return subscription;
    };

    const getTrial = async () => {
        let trial;

        try {
            trial = await getBoostTrial();
        } catch (e) {
            console.log('Error getting trial:', e);
            trial = null;
        }

        return trial;
    };

    const [subscription, trial] = await Promise.all([getSub(), getTrial()]);

    return {
        subscription,
        trial,
    };
};

export * from './customers';
export * from './subscriptions';
export * from './trials';
export * from './types';
